import {
    DestinationEvent,
    transformDestinationEvent,
} from '@eventbrite/event-renderer';
import { gettext } from '@eventbrite/i18n';
import { deepKeysToSnake } from '@eventbrite/transformation-utils';
import isEmpty from 'lodash/isEmpty';
import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import { useMount } from 'react-use';
import { searchEventSuggestions as searchEventSuggestionsAction } from '../../../../../redux/actions/search';
import { DiscoverState } from '../../../../../types';
import SearchEventCardBucket from '../SearchEventCardBucket';

interface EventSuggestionsSectionProps {
    bbox?: string;
    suggestionsLoading?: boolean;
    suggestedEvents?: Record<string, DestinationEvent>;
    searchEventSuggestions: Function;
}

export const EventSuggestionsSection: React.FunctionComponent<
    EventSuggestionsSectionProps
> = ({
    bbox,
    suggestionsLoading = true,
    suggestedEvents = {},
    searchEventSuggestions,
}) => {
    useMount(() => {
        if (!isEmpty(bbox)) {
            searchEventSuggestions(true);
        } else if (isEmpty(suggestedEvents)) {
            searchEventSuggestions();
        }
    });

    const transformedEvents = useMemo(
        () =>
            Object.values(suggestedEvents)
                .slice(0, 6)
                .map<DestinationEvent>(deepKeysToSnake)
                .map(transformDestinationEvent),
        [suggestedEvents],
    );

    if (isEmpty(transformedEvents) && !suggestionsLoading) {
        return null;
    }

    return (
        <SearchEventCardBucket
            events={transformedEvents}
            isLoading={suggestionsLoading}
            bucketName={gettext('Popular events')}
            placeholderCardCount={6}
        />
    );
};

const _mapStateToProps = (state: DiscoverState) => ({
    bbox: state.search.eventSearch.bbox,
    suggestionsLoading: state.suggestions.loading,
    suggestedEvents: state.suggestions.rawEvents,
});

const _mapDispatchToProps = (dispatch: Function) => ({
    searchEventSuggestions: (...args: any) =>
        dispatch(searchEventSuggestionsAction(...args)),
});

export default connect(
    _mapStateToProps,
    _mapDispatchToProps,
)(EventSuggestionsSection);
